export default __webpack_public_path__ + "static/media/Zahl-6.2c144e47.webp";